import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    WhatsAppSyncInitiateInput,
    WhatsAppSyncInitiate as InitiateWhatsAppSyncMutation,
    WhatsAppSyncInitiateVariables as InitiateWhatsAppSyncMutationVariables,
} from 'nutshell-graphql-types';

import INITIATE_WHATSAPP_SYNC from '../mutations/initiate-whatsapp-sync.graphql';

export const useInitiateWhatsAppSync = (): {
    initiateWhatsAppSync: (input: WhatsAppSyncInitiateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [initiateWhatsAppSync, {loading, error}] = useMutation<
        InitiateWhatsAppSyncMutation,
        InitiateWhatsAppSyncMutationVariables
    >(INITIATE_WHATSAPP_SYNC);

    return {
        initiateWhatsAppSync: (input: WhatsAppSyncInitiateInput) => {
            return initiateWhatsAppSync({
                variables: {
                    input,
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
